<ng-container *transloco="let t">
	<div class="content mt-5 box" style="border: silver solid 1px">
		<p class="is-title is-size-6">
			<span
				class="is-inline-flex has-text-white has-background-black has-text-weight-bold p-1 is-title is-size-5">
				{{ t('content.titles.indexedGroupRecord', { index: recordIndex() }) }}
			</span>
		</p>
		<div class="fixed-grid has-1-cols-mobile has-2-cols-tablet is-gapless">
			<div class="grid is-gapless is-gap-1">
				<div class="cell is-flex">
					<div class="is-inline-block mr-2" style="max-width: 110px">
						<eventlyte-dropdown-field
							formKey="salutation"
							[formGroup]="formGroup()"
							[label]="t('fields.salutation.label')"
								[value]="getRecordValue(record, 'salutation')"
							(valueChange)="setRecordValue(record, 'salutation', $event)"
							[editing]="true"
							placeholder=" "
						>
							<eventlyte-tag-field
								value="Mr"
								[label]="t('fields.salutation.options.Mr')"
								[hasExtraText]="false"
							/>
							<eventlyte-tag-field
								value="Miss"
								[label]="t('fields.salutation.options.Miss')"
								[hasExtraText]="false"
							/>
							<eventlyte-tag-field
								value="Ms"
								[label]="t('fields.salutation.options.Ms')"
								[hasExtraText]="false"
							/>
							<eventlyte-tag-field
								value="Dr"
								[label]="t('fields.salutation.options.Dr')"
								[hasExtraText]="false"
							/>
						</eventlyte-dropdown-field>

					</div>
					<div class="is-flex-grow-1">
						<eventlyte-text-field
							formKey="firstName"
							[formGroup]="formGroup()"
							[label]="t('fields.firstName.label')"
								[editing]="true"
							[value]="getRecordValue(record, 'firstName')"
							(valueChange)="setRecordValue(record, 'firstName', $event)" />

					</div>
				</div>
				<div class="cell">
					<eventlyte-text-field
						formKey="lastName"
						[formGroup]="formGroup()"
						[label]="t('fields.lastName.label')"
							[editing]="true"
						[value]="getRecordValue(record, 'lastName')"
						(valueChange)="setRecordValue(record, 'lastName', $event)" />

				</div>
				<div class="cell">
					<eventlyte-text-field
						formKey="companyName"
						[formGroup]="formGroup()"
						[label]="t('fields.companyName.label')"
							[editing]="true"
						[value]="getRecordValue(record, 'companyName')"
						(valueChange)="setRecordValue(record, 'companyName', $event)" />

				</div>
				<div class="cell">
					<eventlyte-text-field
						formKey="jobTitle"
						[formGroup]="formGroup()"
						[label]="t('fields.jobTitle.label')"
							[editing]="true"
						[value]="getRecordValue(record, 'jobTitle')"
						(valueChange)="setRecordValue(record, 'jobTitle', $event)" />

				</div>
				<div class="cell">
					<eventlyte-registration-country-field
						formKey="placeOfResidence"
						[formGroup]="formGroup()"
						[label]="t('fields.placeOfResidence.label')"
							[placeholder]="t('fields.placeOfResidence.label')"
						[editing]="true"
						[value]="getRecordValue(record, 'placeOfResidence')"
						(valueChange)="setRecordValue(record, 'placeOfResidence', $event)"
						[highlighted]="['HK', 'CN']"
					/>

				</div>
				<div class="cell">
					<eventlyte-registration-phone-number-field
						formKey="mobileNumber"
						[formGroup]="formGroup()"
						[label]="t('fields.mobileNumber.label')"
							[editing]="true"
						[countryLocked]="true"
						[value]="getRecordValue(record, 'mobileNumber')"
						(valueChange)="setRecordValue(record, 'mobileNumber', $event)"
						[highlighted]="['HK', 'CN']"
					/>

				</div>

				<div class="cell">
					<eventlyte-email-field
						formKey="emailAddress"
						[formGroup]="formGroup()"
						[label]="t('fields.emailAddress.label')"
							[editing]="true"
						[value]="getRecordValue(record, 'emailAddress')"
						(valueChange)="setRecordValue(record, 'emailAddress', $event)"
					/>


					<div class="has-text-weight-normal is-info is-size-6 message message-body p-2">
						{{ t('content.fields.emailAddressInfo') }}
					</div>
				</div>
				<div class="cell">
					<eventlyte-email-field
						formKey="confirmEmailAddress"
						[formGroup]="formGroup()"
						[label]="t('content.fields.confirmEmailAddress.label')"
						[editing]="true"
						[value]="getRecordValue(record, 'confirmEmailAddress')"
						(valueChange)="setRecordValue(record, 'confirmEmailAddress', $event)" />
				</div>
			</div>
		</div>
	</div>
</ng-container>
